import React from 'react';

import styles from './toggle.scss';

const Toggle = ({ onChange, name, checked }) =>
  <div className="toggle-container">
    <input className="cbx" type="checkbox" checked={checked} onChange={onChange} name={name} />
    <label className="lbl" htmlFor={name}></label>
  </div>

export default Toggle;



// WEBPACK FOOTER //
// ./src/components/forms/Toggle.js